import {Avatar, Box, Flex, Heading, HStack, Text, useDisclosure, VStack} from "@chakra-ui/react";
import {ReactComponent as UserIcon} from "../../../assets/icons/profile/form_user.svg";
import {ReactComponent as MessageIcon} from "../../../assets/icons/profile/envelope.svg";
import {ReactComponent as PhoneIcon} from "../../../assets/icons/formPhone.svg";
import {ReactComponent as TelegramIcon} from "../../../assets/icons/formTg.svg";
import {ReactComponent as PassIcon} from "../../../assets/icons/lock.svg";
import {ReactComponent as EditIcon} from "../../../assets/icons/profile/edit.svg";
import {ReactComponent as DelIcon} from "../../../assets/icons/profile/delete_icon.svg";
import {ReactComponent as DefaultAvatar} from "../../../assets/icons/profile/default_avatar_icon.svg";
import {ReactComponent as Imgchange} from "../../../assets/icons/imgChange.svg";
import {ReactComponent as InvoiceIcon} from "../../../assets/icons/invoice.svg";
import {EditUserModal, InputLabel, StyledButton} from "../../../components";
import React from "react";

export const PersonalInfo = ({user, isMobile}) => {
    const {isOpen, onOpen, onClose} = useDisclosure()

    return (
        <Flex
            gap={'64px'}
            p={'24px'}
            alignItems={isMobile ? 'center' : 'start'}
            direction={isMobile ? 'column' : 'row'}
            w={'full'}
            borderRadius={'16px'}
            bg={'neutral.1100'}>
            <VStack
                gap={'24px'}
                w={isMobile ? 'full' : '224px'}>
                <VStack
                    py={'32px'}
                    gap={'24px'}
                    alignItems={'center'}
                    w={'full'}
                    position={'relative'}
                    maxH={'257px'}
                    borderRadius={'8px'}
                    bg={'neutral.900'}>
                    <Box
                        border={user.avatar ? '8px solid #5834A8' : ''}
                        w={'160px'}
                        h={'160px'}
                        position={'relative'}
                        borderRadius={'50%'}
                        cursor={'pointer'}><img width={'100%'} height={'100%'} style={{borderRadius:'50%'}} src={user.avatar && user.avatar} /> <Imgchange style={{position:'absolute',bottom: '-25px',left: '37%'}} /></Box>
                    <Heading color={'neutral.100'} fontSize={'24px'}>{user.firstName}</Heading>
                </VStack>
                <Box
                    border={'solid 1px #5834A8'}
                    borderRadius={'8px'}
                    w={'full'}
                    p={'8px 24px'}
                    bg={'neutral.900'}>
                    <HStack flexDirection={'column'}>
                        <Text fontSize={'12px'} textAlign={'center'} color={'neutral.500'}>Active until
                            12.04.2025</Text>
                    </HStack>
                    <HStack
                        mt={'17px'}
                        flexDirection={'column'}
                        justifyContent={'space-between'}>
                        <Text fontSize={'18px'} textAlign={'center'} color={'neutral.100'}>Premium</Text>
                    </HStack>
                </Box>
            </VStack>
            <Box
                pb={isMobile ? '24px' : '134px'}
                w={'full'}
                maxW={'788px'}>
                <VStack
                    gap={'24px'}
                    color={'neutral.100'}
                    alignItems={'start'}>
                    <EditUserModal
                        user={user}
                        onClose={onClose}
                        isOpen={isOpen}/>
                    <HStack
                        w={'full'}
                        justifyContent={'space-between'}>
                        <Heading
                            fontSize={'24px'}>
                            Personal information
                        </Heading>
                        <StyledButton bg={'unset'} hoverBg={'unset'} shadowHoverColor={'unset'} fontSizeBase={'14px'}
                                      fontSize={'14px'} border={'solid 1px #353945'} maxWidth={'78px'}>
                            <Flex gap={'8px'} alignItems={'center'}>
                                <Text>Edit</Text>
                                <EditIcon onClick={onOpen} style={{cursor: 'pointer'}}/>
                            </Flex>
                        </StyledButton>
                    </HStack>
                    <Flex
                        gap={'32px'}
                        w={'100%'}
                        justifyContent={'space-between'}
                    >
                        <VStack
                            w={'100%'}
                            maxW={'354px'}
                            flexDirection={'column'}
                            alignItems={'flex-start'}
                        >
                            <Flex gap={'8px'}>
                                <UserIcon/>
                                <Text color={'neutral.600'} fontSize={'16px'}>Full Name</Text>
                            </Flex>
                            <InputLabel
                                bg={'transparent'}
                                paddingLeft={'0'}
                                type={'text'}
                                border={'none'}
                                borderBottom={'solid 1px #777E90'}
                                maxW={'354px'}
                                maxH={'56px'}
                                color={'neutral.500'}
                                value={user.firstName + ' ' + user.lastName}
                                borderRadius={'0'}
                            />
                        </VStack>
                        <VStack
                            w={'100%'}
                            maxW={'354px'}
                            flexDirection={'column'}
                            alignItems={'flex-start'}
                        >
                            <Flex gap={'8px'}>
                                <MessageIcon/>
                                <Text color={'neutral.600'} fontSize={'16px'}>Email</Text>
                            </Flex>
                            <InputLabel
                                bg={'transparent'}
                                paddingLeft={'0'}
                                type={'text'}
                                border={'none'}
                                borderBottom={'solid 1px #777E90'}
                                maxW={'354px'}
                                maxH={'56px'}
                                color={'neutral.500'}
                                value={user.email}
                                borderRadius={'0'}
                            />
                        </VStack>
                    </Flex>
                    <Flex
                        gap={'32px'}
                        w={'100%'}
                        justifyContent={'space-between'}
                    >
                        <VStack
                            w={'100%'}
                            maxW={'354px'}
                            flexDirection={'column'}
                            alignItems={'flex-start'}
                        >
                            <Flex gap={'8px'}>
                                <PhoneIcon/>
                                <Text color={'neutral.600'} fontSize={'16px'}>Phone Number</Text>
                            </Flex>
                            <InputLabel
                                bg={'transparent'}
                                paddingLeft={'0'}
                                type={'text'}
                                border={'none'}
                                borderBottom={'solid 1px #777E90'}
                                maxW={'354px'}
                                maxH={'56px'}
                                color={'neutral.500'}
                                value={user.phone}
                                borderRadius={'0'}
                            />
                        </VStack>
                        <VStack
                            w={'100%'}
                            maxW={'354px'}
                            flexDirection={'column'}
                            alignItems={'flex-start'}
                        >
                            <Flex gap={'8px'}>
                                <TelegramIcon/>
                                <Text color={'neutral.600'} fontSize={'16px'}>Telegram Nickname</Text>
                            </Flex>
                            <InputLabel
                                bg={'transparent'}
                                paddingLeft={'0'}
                                type={'text'}
                                border={'none'}
                                borderBottom={'solid 1px #777E90'}
                                maxW={'354px'}
                                maxH={'56px'}
                                color={'neutral.500'}
                                value={user.telegramNic}
                                borderRadius={'0'}
                            />
                        </VStack>
                    </Flex>
                    <Text
                        fontWeight={'500'}
                        fontSize={'18px'}>
                        Password management
                    </Text>
                    <form style={{width: '100%', maxWidth: '527px'}}>
                        <VStack
                            alignItems={'end'}
                            gap={'24px'}>
                            <InputLabel
                                leftAddon={<PassIcon/>}
                                type={'password'}
                                placeholder={'Password'}
                                label={'Password'}
                                bg={'neutral.900'}
                            />
                            <InputLabel
                                leftAddon={<PassIcon/>}
                                type={'password'}
                                placeholder={'Old Password'}
                                label={'Repeat Password'}
                                bg={'neutral.900'}
                            />
                            <InputLabel
                                leftAddon={<PassIcon/>}
                                type={'password'}
                                placeholder={'Re-enter Password'}
                                label={'Re-enter Password'}
                                bg={'neutral.900'}
                            />
                            <Flex gap={'16px'} w={'100%'}>
                                <StyledButton
                                    bg={'#6F41D240'}
                                    border={'solid 1px #5834A8'}
                                    w={isMobile ? 'full' : '84px'}
                                    fontSize={'body.md'}
                                    type={'submit'}>
                                    Cancel
                                </StyledButton>
                                <StyledButton
                                    w={isMobile ? 'full' : '84px'}
                                    fontSize={'body.md'}
                                    type={'submit'}>
                                    Save
                                </StyledButton>
                            </Flex>

                        </VStack>
                    </form>
                </VStack>
            </Box>
        </Flex>
    )
}